import * as ActionTypes from "../actions/ActionTypes";
import initialState from "./InitialState";
import { stat } from "fs";

export const ModalReducer = function (state = initialState.responseData, action: any) {
    switch (action.type) {
        case ActionTypes.SHOW_MODAL:
            return { ...state, showModal: action.showModal};
        case ActionTypes.MODAL_CONFIG:
            return { ...state, responseData: action.responseData};
        case ActionTypes.FETCH_PATIENT_PAST_SESSIONS_SUCCESS:
            return { ...state, responseData: action.responseData};
        case ActionTypes.UPDATE_MODAL_UI_CONFIG:
            return { ...state, modalUIConfig: action.modalUIConfig}
        case ActionTypes.UPDATE_FORMATTED_CONFIG_AVAILABLE:
            return {...state, formattedConfigAvailable: action.formattedConfigAvailable}
        case ActionTypes.ADD_BUTTON_CLICKED: 
            return {...state, status: action.status}
        default:
            return state;
    }
};
